import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CeRequestOptions } from "../../request-creation/request-header/request-header.component";
import { FacilityTypeService } from "./facility-type.service";
import { CeSiteService } from "./ce-site.service";
import { CropService } from "./crop.service";
import { RequestPurposeService } from "./request-purpose.service";
import { ProductConceptService } from "./product-concept.service";
import { SubstrateService } from "./substrate.service";
import { IrrigationMethodService } from "./irrigation-method.service";
import { FertigationMethodService } from "./fertigation-method.service";
import { LightingInstructionService } from "./lighting-instruction.service";
import { TemperatureInstructionService } from "./temperature-instruction.service";
import { HumidityInstructionService } from "./humidity-instruction.service";
import { PesticideInstructionService } from "./pesticide-instruction.service";
import { PollinationCategoryService } from "./pollination-category.service";
import { PmoProgramService } from "./pmo-program.service";
import { ContainerDefinitionService } from "./container-definition.service";
import { UserService } from "./user.service";
import { LaboratoryService } from "./laboratory.service";
import { GrowthStageService } from "./growth-stage.service";
import { TissueTypeService } from "./tissue-type.service";
import { PollinationTypeService } from "./pollination-type.service";
import { ProjectedTaskConfigurationService } from "./projected-task-configuration.service";
import { SprayBoothStudyService } from "./spray-booth-study.service";

@Injectable()
export class RequestOptionsService {
  constructor(
    private ceSiteService: CeSiteService,
    private cropService: CropService,
    private requestPurposeService: RequestPurposeService,
    private facilityTypeService: FacilityTypeService,
    private productConceptService: ProductConceptService,
    private pmoProgramService: PmoProgramService,
    private substrateService: SubstrateService,
    private irrigationMethodService: IrrigationMethodService,
    private fertigationMethodService: FertigationMethodService,
    private lightingInstructionService: LightingInstructionService,
    private temperatureInstructionService: TemperatureInstructionService,
    private humidityInstructionService: HumidityInstructionService,
    private pesticideInstructionService: PesticideInstructionService,
    private pollinationCategoryService: PollinationCategoryService,
    private containerDefinitionService: ContainerDefinitionService,
    private userService: UserService,
    private pollinationTypeService: PollinationTypeService,
    private laboratoryService: LaboratoryService,
    private growthStageService: GrowthStageService,
    private tissueTypeService: TissueTypeService,
    private projectedTaskConfigurationService: ProjectedTaskConfigurationService,
    private sprayStudyService: SprayBoothStudyService
  ) { }

  public options = (): Observable<any> => {
    return Observable.forkJoin(
      this.ceSiteService.getAll(),
      this.cropService.getAll(),
      this.requestPurposeService.getAll(),
      this.facilityTypeService.getAll(),
      this.productConceptService.getAll(),
      this.pmoProgramService.getAllPrograms(),
      this.substrateService.getAll(),
      this.irrigationMethodService.getAll(),
      this.fertigationMethodService.getAll(),
      this.lightingInstructionService.getAll(),
      this.temperatureInstructionService.getAll(),
      this.humidityInstructionService.getAll(),
      this.pesticideInstructionService.getAll(),
      this.pollinationCategoryService.getAll(),
      this.containerDefinitionService.getFlats(),
      this.containerDefinitionService.getPots(),
      this.userService.getAll(),
      this.pollinationTypeService.getAll(),
      this.laboratoryService.getAll(),
      this.growthStageService.getAll(),
      this.tissueTypeService.getAll(),
      this.projectedTaskConfigurationService.getAll(),
      this.sprayStudyService.getAllActives(),
      this.sprayStudyService.getAllAdjuvantUnits(),
      this.sprayStudyService.getAllAdjuvants(),
      this.sprayStudyService.getAllTimepoints(),
      this.sprayStudyService.getAllVolumes(),
      this.sprayStudyService.getAllRateUnits()
    ).map(
      ([
        cesites,
        crops,
        requestpurposes,
        facilitytypes,
        productconcepts,
        pmoprograms,
        substrates,
        irrigationMethods,
        fertigationMethods,
        lightinginstructions,
        temperatureinstructions,
        humidityinstructions,
        pesticideinstructions,
        pollinationcategories,
        flatTypes,
        potTypes,
        users,
        pollinationTypes,
        laboratories,
        growthStages,
        tissueTypes,
        projectedTaskConfigurations,
        actives,
        adjuvantUnits,
        adjuvants,
        applicationTimepoints,
        applicationVolumes,
        rateUnits
      ]) =>
        <CeRequestOptions>{
          userPreference: null,
          ceSites: cesites,
          crops: crops,
          requestPurposes: requestpurposes,
          facilityTypes: facilitytypes,
          productConcepts: productconcepts,
          pmoPrograms: pmoprograms,
          substrates: substrates,
          irrigations: irrigationMethods,
          fertigations: fertigationMethods,
          lightingInstructions: lightinginstructions,
          temperatureInstructions: temperatureinstructions,
          humidityInstructions: humidityinstructions,
          pesticideInstructions: pesticideinstructions,
          pollinationCategories: pollinationcategories,
          flatTypes: flatTypes,
          potTypes: potTypes,
          users: users,
          pollinationTypes: pollinationTypes,
          growthStages: growthStages,
          laboratories: laboratories,
          tissueTypes: tissueTypes,
          projectedTaskConfigurations: projectedTaskConfigurations,
          actives: actives,
          adjuvantUnits: adjuvantUnits,
          adjuvants: adjuvants,
          applicationTimepoints: applicationTimepoints,
          applicationVolumes: applicationVolumes,
          rateUnits: rateUnits
        }
    );
  };
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/request-options.service.ts